import creditoService from '@/servicios/credito'
import { ERROR_OBTENER_PAGO_SIMULADO } from '@/utilidades/errores'

export const ObtieneCreditoPagoSimuladoMixin = {
  data: () => ({
    consumiendoCreditoPagoSimulado: false,
  }),
  methods: {
    // Metodos publicos
    obtieneCreditoPagoSimulado(request = null) {
      this.$_ObtieneCreditoPagoSimuladoMixin_IniciaObtieneCreditoPagoSimulado()
      creditoService
        .obtenerPagoSimulado(request)
        .then((result) => {
          this.$_ObtieneCreditoPagoSimuladoMixin_TerminaObtieneCreditoPagoSimulado()
          if (result.status != 200) {
            this.errorObtieneCreditoPagoSimulado(ERROR_OBTENER_PAGO_SIMULADO)
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            this.errorObtieneCreditoPagoSimulado(data.Mensaje)
            return
          }
          this.postObtieneCreditoPagoSimulado(data.Modelo)
        })
        .catch((err) => {
          this.$_ObtieneCreditoPagoSimuladoMixin_TerminaObtieneCreditoPagoSimulado()
          console.error(err)
          this.errorObtieneCreditoPagoSimulado(ERROR_OBTENER_PAGO_SIMULADO)
        })
    },
    postObtieneCreditoPagoSimulado() {},
    errorObtieneCreditoPagoSimulado(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_ObtieneCreditoPagoSimuladoMixin_IniciaObtieneCreditoPagoSimulado() {
      this.consumiendoCreditoPagoSimulado = true
    },
    $_ObtieneCreditoPagoSimuladoMixin_TerminaObtieneCreditoPagoSimulado() {
      this.consumiendoCreditoPagoSimulado = false
    },
  },
}
